import React, { useState, useEffect } from "react";
import {
  IonSlides,
  IonSlide,
  IonImg,
  IonLabel,
  IonCol,
  IonRow,
  IonText,
  IonContent,
  IonList,
  IonRadioGroup,
  IonItem,
  IonRadio,
} from "@ionic/react";
import * as constants from "../../constants";

interface carBrandsProps {
  vehicleVariant: Array<any>;
  saveVehicleVariant: Function;
  selectedVariant: string;
  searchData: string;
  handleKeypressVariant: Function;
}

const SelectVariant: React.FC<carBrandsProps> = ({
  vehicleVariant,
  saveVehicleVariant,
  selectedVariant,
  searchData,
  handleKeypressVariant,
}: carBrandsProps) => {
  const [state, setState] = useState("");
  React.useEffect(() => {
    const response = (vehicleVariant.find((ele: any) => ele.vehicleId === selectedVariant) || {})
      .name;
    setState(response);
  }, [selectedVariant]);

  const handleSearch = (data: any, searchData: any) => {
    if (!!searchData) {
      return data.filter((ele: any) => {
        if (
          Object.keys(ele).some((key: any) => {
            return ele[key].toLowerCase().includes(searchData.toLowerCase());
          })
        ) {
          return ele;
        }
        // return ele.name.toLowerCase().includes(searchData.toLowerCase());
      });
    }
    return data;
  };

  return (
    <>
      <IonRow
        className={
          handleSearch(vehicleVariant, searchData).length
            ? "brands_div margin-left-right-0"
            : "no-variants-layout margin-left-right-0"
        }
      >
        {handleSearch(vehicleVariant, searchData).length ? (
          <>
            <IonRadioGroup value={state}>
              {handleSearch(vehicleVariant, searchData).map((ele: any, index: any) => (
                <IonItem className="border_bottom" lines="none">
                  <IonLabel className="radio_label" class="item-text-wrap" text-wrap>
                    {ele.name} {ele.fuelType}
                  </IonLabel>
                  <IonRadio
                    mode="md"
                    tabIndex={0}
                    slot="start"
                    value={ele.name}
                    onClick={() => saveVehicleVariant(ele.vehicleId, ele.fuelType, ele.name)}
                    color="primary"
                    onKeyPress={(event) =>
                      handleKeypressVariant(event, ele.vehicleId, ele.fuelType, ele.name)
                    }
                  />
                </IonItem>
              ))}
            </IonRadioGroup>
          </>
        ) : (
          <div>
            <h3 color="secondary">{constants.NO_VARIANTS_FOUND}</h3>
          </div>
        )}
      </IonRow>
    </>
  );
};

export default SelectVariant;
